import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowDownToLine, ArrowUpFromLine, Boxes, RefreshCw } from "lucide-react";
import { API } from "../../../lib/apiClient";
import { Field, Modal } from "../Shared";

export function StockModal({ item, onClose, onSaved }) {
  const [type, setType] = useState("ADD");
  const [qty, setQty] = useState("");
  const [reason, setReason] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/inventory/transaction`, { item_id: item.id, type, quantity_changed: Number(qty), reason: reason || `${type} stock` });
      toast.success("Stock updated");
      onSaved(); onClose();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not update stock"); }
  };
  return <Modal title="Update stock" onClose={onClose}>
    <div className="modal-item"><div className="item-mark green"><Boxes size={17} /></div><div><b data-testid="stock-modal-item-name">{item.name}</b><span>Current balance: {item.quantity} {item.unit}</span></div></div>
    <form onSubmit={submit} className="modal-form">
      <div className="action-toggle">{[["ADD", "Add stock", ArrowDownToLine], ["ISSUE", "Issue stock", ArrowUpFromLine], ["ADJUSTMENT", "Set balance", RefreshCw]].map(([value, label, Icon]) => <button type="button" key={value} data-testid={`stock-type-${value.toLowerCase()}-button`} className={type === value ? "selected" : ""} onClick={() => setType(value)}><Icon size={16} />{label}</button>)}</div>
      <Field label={type === "ADJUSTMENT" ? "New balance" : `Quantity (${item.unit})`} name="quantity" type="number" step="0.01" value={qty} onChange={(e) => setQty(e.target.value)} required testid="stock-quantity-input" />
      <Field label="Reason" name="reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Production run 24" testid="stock-reason-input" />
      <div className="modal-actions">
        <button type="button" className="button ghost" data-testid="stock-cancel-button" onClick={onClose}>Cancel</button>
        <button type="submit" className="button primary" data-testid="stock-save-button">Save movement</button>
      </div>
    </form>
  </Modal>;
}
